import type { SessionService, SessionState } from '@efdigital/ll-addon-auth';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { Await } from '@warp-drive/ember';

interface UserProfileButtonSignature {
  Element: HTMLButtonElement;
}

function initials(state: SessionState) {
  const letters =
    state.displayName
      ?.split(' ')
      .map((name) => name[0])
      .join('')
      .toUpperCase() || '';
  if (letters.length > 2) {
    return letters[0]! + letters[letters.length - 1]!;
  }
  if (letters.length === 0) {
    return '@';
  }
  return letters;
}

export default class UserProfileButton extends Component<UserProfileButtonSignature> {
  @service declare session: SessionService;

  get user() {
    return this.session.getCurrent();
  }

  <template>
    <Await @promise={{this.user}}>
      <:success as |user|>
        <button
          type="button"
          class="d-flex align-items-center gap-3 border-0 border-top bg-transparent text-start px-3 py-3 w-100"
          ...attributes
        >
          <span
            class="ll-avatar-xs rounded-circle text-bg-primary d-inline-flex align-items-center justify-content-center fw-bold flex-shrink-0"
            aria-hidden="true"
          >{{initials user}}</span>
          <span class="min-w-0">
            <span
              class="d-block fw-bold text-truncate"
            >{{user.displayName}}</span>
            {{#if user.client.title}}
              <span
                class="d-block text-body-secondary text-truncate small"
              >{{user.client.title}}</span>
            {{/if}}
          </span>
        </button>
      </:success>
    </Await>
  </template>
}
